import queryString from 'query-string';
import { rootDomain, isPreview as isPreviewEnv, isStaging, vercelProtectionBypass, storeUrl } from './env';
import getStorePreviewOrigin from './getStorePreviewOrigin';

/**
 * Vercel preview deployments and instance dev stacks both serve the store from a
 * single host with no wildcard subdomain, so the seller moves out of the hostname
 * and into the path.
 */
function toPathBasedHost(checkoutUrl, baseUrl, sellerUrlId, pageUrlId) {
  const rewritten = checkoutUrl.replace(`https://${sellerUrlId}.${rootDomain}`, baseUrl);

  if (rewritten.includes('embed') || rewritten.includes('overlay')) {
    return rewritten.replace(`/${pageUrlId}`, `/${sellerUrlId}/${pageUrlId}`);
  }

  return rewritten.replace(`/${pageUrlId}`, `/c/${sellerUrlId}/${pageUrlId}`);
}

export default function getCheckoutPreviewUrl(
  page = {},
  seller = {},
  {
    isTesting = false,
    isTestingPayments = false,
    isPreview = false,
    variant,
    previewKey,
    isConfirmation = false,
    usePageId = false,
  } = {},
) {
  const pageUrlId = usePageId ? page._id : page.slug || page._id;
  const sellerUrlId = seller.name ? seller.name : seller._id;

  let checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}`;

  if (variant === 'site_embed' || variant === 'site_upsell_embed') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/embed/${pageUrlId}`;
  }

  if (variant === 'site_popup' || variant === 'site_upsell_popup') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/overlay/${pageUrlId}`;
  }

  if (variant === 'qr_code') {
    checkoutUrl = `https://${sellerUrlId}.${rootDomain}/${pageUrlId}/qr`;
  }

  // if the environment is preview, we need to replace the root domain with the store host
  if (isPreviewEnv && !isStaging) {
    const previewBranchUrl = getStorePreviewOrigin();

    // replace the root domain with the store preview branch url
    if (previewBranchUrl) {
      checkoutUrl = toPathBasedHost(checkoutUrl, previewBranchUrl, sellerUrlId, pageUrlId);
    }
  } else if (storeUrl) {
    checkoutUrl = toPathBasedHost(checkoutUrl, storeUrl, sellerUrlId, pageUrlId);
  }

  if (isConfirmation) {
    checkoutUrl = `${checkoutUrl}/confirmation/${Math.random()}`;
  }

  const url = queryString.stringifyUrl({
    url: checkoutUrl,
    query: {
      ...(isTesting && { testing: true }),
      ...(isTestingPayments && { testingPayments: true }),
      ...(isPreview && { preview: true }),
      ...(previewKey && { previewKey }),
      ...((variant === 'hosted_upsell_page' ||
        variant === 'site_upsell_embed' ||
        variant === 'site_upsell_popup') && {
        upsell: true,
      }),
      ...(isPreviewEnv && vercelProtectionBypass && {
        'x-vercel-protection-bypass': vercelProtectionBypass,
        'x-vercel-set-bypass-cookie': 'samesitenone',
      }),
    },
  });

  return url;
}
